import React from 'react'
import Image from "../../elements/Image"
 
const OurVission = ({ data }) => {
  return (
    <>
      <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4 pt-28">
        <div className="relative">
          <div className="relative flex flex-col">
            <h4 className="text-xl font-semibold mb-2 text-primary uppercase text-center leading-5">{data.title}</h4>
            <h2 className="text-5xl font-semibold text-center text-white leading-normal mb-2">{data.heading}</h2>
            <div className="max-w-[1110px] w-full leading-7 text-secondary text-center mx-auto">
              <p>{data.description}</p>
            </div>
          </div>
          <div className="relative w-full grid grid-cols-1  lg:grid-cols-2 gap-6 mt-12 text-white max-w-screen-xl ml-auto mr-auto">
            {data.items.map((item, index) => (
            <div className="relative border border-borderColor rounded-lg px-9 py-8">
              <div className="flex items-center  space-x-3 mb-5 text-white">
                <Image
                  src={item.icon}
                  key={index}
                  width={40}
                  height={40}
                  alt=""
                  effect=""
                  classes="!w-10 !h-10 overflow-hidden"
                />
                <h4 className="text-2xl leading-4 font-semibold">{item.title}</h4>
              </div>
              <div className="text-lg leading-7 text-secondary">
                <p>{item.description}</p>
              </div>
            </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default OurVission